import { AccordionGroup, AccordionItem } from '@theme/accordions';
import { classes, events } from '@theme/constants';
import { on, updateSectionElements } from '@theme/dom';
import { publish, subscribe } from '@theme/event-bus';
import { gsap } from '@theme/gsap';
import { ScrollTrigger } from '@theme/gsap-scrolltrigger';
import { SelectProvider } from '@theme/select-provider';
import { ToggleButton, ToggleElement } from '@theme/toggle-element';

gsap.registerPlugin(ScrollTrigger);

/**
 * Keyboard events.
 */
on('keyup', document, (event) => {
  if (event.key === 'Escape') publish(events.escapeKey);
});

if (theme.request.page_type === 'collection') {
  on('pageshow', window, (event) => {
    if (event.persisted) {
      window.location.reload();
    }

    window.history.scrollRestoration = 'manual';
  });
}

/**
 * Custom elements.
 */
customElements.define('accordion-group', AccordionGroup);
customElements.define('accordion-item', AccordionItem);
customElements.define('select-provider', SelectProvider);
customElements.define('toggle-element', ToggleElement);
customElements.define('toggle-button', ToggleButton);

/**
 * Handles Section Rendering API events.
 */
subscribe(events.sectionUpdate, async ({ sections, onAfterElementsUpdated }) => {
  await Promise.all(
    Object.entries(sections).map(([sectionId, sectionHtml]) => updateSectionElements(sectionId, sectionHtml)),
  );

  if (typeof onAfterElementsUpdated === 'function') {
    onAfterElementsUpdated();
  }
});

on(
  'keydown',
  document,
  (event) => {
    if (event.keyCode === 9) {
      document.body.classList.add(classes.tabbable);
    }
  },
  { once: true },
);
